import { render, staticRenderFns } from "./PurchaseOrderResourceList.vue?vue&type=template&id=535c0e0c&"
import script from "./PurchaseOrderResourceList.vue?vue&type=script&lang=js&"
export * from "./PurchaseOrderResourceList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports